import { createAsync , query} from "@solidjs/router";
import { Show, createSignal, onMount, createEffect, createMemo } from "solid-js";

import { getByUserQuery, getByPKQuery, formatLongDate, orderedJoin, schemeData, padId, RIASRecordType } from "~/lib";
import {queryByPK} from "~/_server/dynamoDB";

export const Subscription = props => {
	const [subscription, setSubscription] = createSignal( props.subscription );
	const [approvedBody, setApprovedBody] = createSignal();

	onMount( async () => {
		if ( !props.subscription && props.subscriptionId ) {
			const s = await getByUserQuery( 'SCHEME', props.scheme.id );

			setSubscription( s.SCHEME );
		}
	} );

	//const approvedBody = createAsync( () => getByPKQuery( `APPROVEDBODY#${subscription().approvedBodyId}`, null) );
		
	createEffect( async () => {
		if ( subscription().approvedBodyId ) {
			const ab = await queryByPK( `APPROVEDBODY#${subscription().approvedBodyId}`, '' );

			if ( ab && ab.length > 0 ) {
				setApprovedBody( ab[0] );
			}
		}
	} );

	const ABDisplay =() => <>{approvedBody()?.address?.title} - <em>{approvedBody()?.riasId ? approvedBody()?.scheme+'-DB-'+ padId(approvedBody().riasId):'n/a' }</em></>;
	

	return (
		<>
			<Show when={!props.longForm}>
				<div class="grid grid-cols-2 gap-3" onClick={props.onClick} classList={props.classList}>
					<span>{schemeData( subscription().scheme).name}</span>
					<span>{subscription().name}</span>
					<span class="col-span-2"><ABDisplay /></span>
					<span class="col-span-2 text-xs mt-1.5">Expires {formatLongDate( subscription().expires )}</span>
				</div>
			</Show>

			<Show when={props.longForm}>
				<table class="relative min-w-full divide-y divide-gray-300">
					<tbody>
						<tr class="even:bg-gray-100">
							<td class="text-nowrap py-2 px-2 text-xs text-right">Certifier ID:</td>
							<td class="font-bold py-2 text-sm">{subscription().name}</td>
						</tr>
						<tr class="even:bg-gray-100">
							<td class="text-nowrap py-2 px-2 text-xs text-right">Status:</td>
							<td class="font-bold py-2 capitalize text-sm">{subscription().status}</td>
						</tr>
						<tr class="even:bg-gray-100">
							<td class="text-nowrap py-2 px-2 text-xs text-right">Renewal Date:</td>
							<td class="font-bold py-2 text-sm">{formatLongDate( subscription().expires )}</td>
						</tr>
						<tr class="even:bg-gray-100">
							<td class="text-nowrap py-2 px-2 text-xs text-right">Approved Body:</td>
							<td class="font-bold py-2 text-sm"><ABDisplay /></td>
						</tr>
						<tr class="even:bg-gray-100">
							<td class="text-nowrap py-2 px-2 text-xs text-right align-baseline">Address:</td>
							<td class="font-bold py-2 text-sm">{ orderedJoin( approvedBody()?.address, ["addr1", "addr2","town","county","postcode"], ", " )}</td>
						</tr>
						<tr class="even:bg-gray-100">
							<td class="text-nowrap py-2 px-2 text-xs text-right">Co-ordinator:</td>
							<td class="font-bold py-2 text-sm" innerHTML={approvedBody()?.coordinator ?? 'n/a'} />
						</tr>
						<tr class="even:bg-gray-100">
							<td class="text-nowrap py-2 px-2 text-xs text-right">Deputy:</td>
							<td class="font-bold py-2 text-sm" innerHTML={approvedBody()?.deputy ?? 'n/a'} />
						</tr>
					</tbody>
				</table>
			</Show>
		</>
	);
}